import { useState, useMemo, useCallback } from 'react';
import type { DailyEarning } from '../types';
import { computeDayBuckets, type DayBucket } from '../utils/chart-buckets';

type Result = {
  ref: (el: HTMLDivElement | null) => void;
  buckets: DayBucket[];
  maxH: number;
  hasData: boolean;
};

export function useChartData(daily: DailyEarning[]): Result {
  const [w, setW] = useState(600);
  const ref = useCallback((el: HTMLDivElement | null) => {
    if (el) setW(el.clientWidth);
  }, []);
  const buckets = useMemo(() => computeDayBuckets(daily, w), [daily, w]);
  const maxH = useMemo(
    () => Math.max(...buckets.map((b) => b.count), 110),
    [buckets]
  );
  return { ref, buckets, maxH, hasData: buckets.some((b) => b.count > 0) };
}
